import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import SaleFilterGroup from 'components/research_property/sale_filter_group';
import LeaseFilterGroup from 'components/research_property/lease_filter_group';

import { clearFiltersIfEmpty, changeSaleFilterGroup } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

export class SaleOrLeaseFilterGroup extends React.Component {
  static propTypes = {
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    leaseSpaceTypeMappings: PropTypes.array.isRequired,
    leaseTypeMappings: PropTypes.array.isRequired,
    leaseUnits: PropTypes.array.isRequired,
    saleFilter: PropTypes.shape({
      leaseRateUnits: PropTypes.string.isRequired,
      leaseType: PropTypes.string.isRequired,
      maxCapRate: PropTypes.string,
      maxLeaseDate: PropTypes.string,
      maxLeasePrice: PropTypes.string,
      maxLeaseSize: PropTypes.string,
      maxSalesDate: PropTypes.string,
      maxSalesPrice: PropTypes.string,
      maxSfPrice: PropTypes.string,
      maxUnitPrice: PropTypes.string,
      minCapRate: PropTypes.string,
      minLeaseDate: PropTypes.string,
      minLeasePrice: PropTypes.string,
      minLeaseSize: PropTypes.string,
      minSalesDate: PropTypes.string,
      minSalesPrice: PropTypes.string,
      minSfPrice: PropTypes.string,
      minUnitPrice: PropTypes.string
    }).isRequired,
    onSaleFilterChange: PropTypes.func.isRequired
  };

  state = {
    selectedFilter: 'sale'
  };

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleChange = (e, name) => {
    const { saleFilter, onSaleFilterChange } = this.props;

    let value = '';
    if (e && e.target) {
      value = e.target.value;
    } else {
      value = e;
    }

    saleFilter[name] = value;
    onSaleFilterChange(saleFilter);
    this.handleRetrieveRecords();
  };

  selectFilter = (filter) => {
    this.setState({ selectedFilter: filter });
  }

  render() {
    return (
      <React.Fragment>
        {this.renderFilters()}
      </React.Fragment>
    );
  }

  renderFilters() {
    const activeFilter = classNames({
      'sale-lease-buttons': true,
      'active': true
    });

    const inactiveFilter = classNames({
      'sale-lease-buttons': true,
      'active': false
    });

    const { selectedFilter } = this.state;

    return (
      <React.Fragment>
        <div className="sale-lease-buttons-container">
          <div
            className={selectedFilter === 'sale' ? activeFilter : inactiveFilter}
            onClick={() => this.selectFilter('sale')}
          >
            Sale
          </div>
          <div
            className={selectedFilter === 'lease' ? activeFilter : inactiveFilter}
            onClick={() => this.selectFilter('lease')}
          >
            Lease
          </div>
        </div>
        {selectedFilter === 'sale' ? this.renderSaleFilters() : this.renderLeaseFilters()}
      </React.Fragment>
    );
  }

  renderSaleFilters() {
    const { saleFilter } = this.props;

    return (
      <SaleFilterGroup
        saleFilter={saleFilter}
        onFilterChange={this.handleChange}
      />
    );
  }

  renderLeaseFilters() {
    const {
      leaseSpaceTypeMappings,
      leaseTypeMappings,
      leaseUnits,
      saleFilter
    } = this.props;

    return (
      <LeaseFilterGroup
        leaseFilter={saleFilter}
        leaseSpaceTypeMappings={leaseSpaceTypeMappings}
        leaseTypeMappings={leaseTypeMappings}
        leaseUnits={leaseUnits}
        onFilterChange={this.handleChange}
      />
    );
  }
}


const mapStateToProps = state => ({
  leaseSpaceTypeMappings: state.static.leaseSpaceTypes,
  leaseTypeMappings: state.static.leaseTypes,
  leaseUnits: state.static.leaseUnits,
  saleFilter: state.query.saleFilter
});


const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  onSaleFilterChange: changeSaleFilterGroup
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleOrLeaseFilterGroup);

